"use client";

import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "react-leaflet-markercluster/styles";
import S from "./index.module.scss";
import AddressesInput from "./input";
import AddressesCluster from "./cluster";
import AddressesProvider from "./provider";

const AddressesMap = () => {
  return (
    <div className={S.wrapper}>
      <AddressesInput />
      <MapContainer minZoom={4} center={[50, 30]} zoom={5} style={{ height: "100%", width: "100%" }}>
        <AddressesProvider />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          maxZoom={14}
        />
        <AddressesCluster />
      </MapContainer>
    </div>
  );
};

export default AddressesMap;
